import { useCurrentUserContext } from 'contexts/currentUser';

export const useCoinBalance = () => {
  const { currentUser } = useCurrentUserContext();

  return {
    coinBalance: currentUser?.coinBalance || 0,
  };
};
